import { Button } from '../Button';
import React from 'react';
import styled, { css } from 'styled-components';
import { IPageListButtonRendererProps } from 'react-bootstrap-table2-paginator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';

const PageListButton = styled(Button)<{ active: boolean }>`
  border: 0;
  border-radius: ${(props) => props.theme.spacing.spacing2};
  min-height: auto;
  padding: ${(props) => `0 ${props.theme.spacing.spacing4}`};
  ${(props) =>
    props.active &&
    css`
      font: ${(props) => props.theme.fonts.mixins.boldSmallButton};
    `};
`;

const convertToChevrons = (me: string) => {
  switch (me) {
    case '<<':
      return <FontAwesomeIcon icon={faChevronDoubleLeft} />;
    case '<':
      return <FontAwesomeIcon icon={faChevronLeft} />;
    case '>':
      return <FontAwesomeIcon icon={faChevronRight} />;
    case '>>':
      return <FontAwesomeIcon icon={faChevronDoubleRight} />;
    default:
      return me;
  }
};

export const PageButtonRenderer: React.FC<IPageListButtonRendererProps> = ({
  page,
  title,
  active,
  disabled,
  onPageChange,
}) => (
  <PageListButton
    intent={active ? 'primary' : 'secondary'}
    type="button"
    active={active}
    disabled={disabled}
    onClick={() => onPageChange(page)}
    title={title}
  >
    {typeof page === 'number' ? page : convertToChevrons(page)}
  </PageListButton>
);
